<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="getData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.admin_name" placeholder="请输入管理员名称" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="adminName" label="管理员名称"></el-table-column>
            <el-table-column label="管理员状态">
                <template slot-scope="scope">
                    {{ scope.row.adminStatus == 1 ? "启用" : "禁用" }}
                </template>
            </el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.adminDate) }}
                </template>
            </el-table-column>

            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="90px">
                    <el-form-item label="管理员名称">
                        <el-input v-model="handleInfo.adminName"></el-input>
                    </el-form-item>
                    <el-form-item label="管理员密码">
                        <el-input v-model="handleInfo.adminPassword" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="管理员状态">
                        <el-select v-model="handleInfo.adminStatus" placeholder="请选择" style="width: 100%;">
                            <el-option label="启用" :value="1"></el-option>
                            <el-option label="禁用" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"

import { API, doGet } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin],
    data: function () {
        return {
        }
    },
    methods: {
        getData: async function() {
            this.initialData();
        }
    },
    created: function () {
        this.tag = "ADMIN";
        this.getData();
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>